$(document).ready(function () {
  function addIframeTitle() {
    $('iframe').each(function (i, elem) {
      if (!$(elem).attr('title')) {
        var num = 1 + Math.floor(Math.random() * 10000);
        if ($(elem).css('display') == 'none' || $(elem).css("visibility") == "hidden") {
          $(elem).attr('title', 'Dynamically Generated hidden Iframe - ' + num);
        } else {
          $(elem).attr('title', 'Dynamically Generated Iframe - ' + num);
        }
      }
    })
    if ($('#google-map').length > 0) {
      var _iframe = $('iframe')
      $('#google-map').each(function (i, map) {
        $(map).find(_iframe).each(function (k, frame) {
          $(frame).attr('title', 'Google Map');
        })
      });
    }
  }
  for (var i = 0; i < 5; i++) {
    setTimeout(addIframeTitle, 2000 * i);
  }
});
